import {
  Box,
  Button,
  ButtonIcon,
  ContentBlock,
  IconClear,
  Spread,
  Text,
} from 'braid-design-system';

export type UserPanelProps = {
  email: string | null;
  onLogout: () => void;
};

export const UserPanel = ({ email, onLogout }: UserPanelProps) => (
  <Box background="customDark" style={{ backgroundColor: '#008080' }}>
    <ContentBlock>
      <Box paddingX="gutter" paddingY="small">
        <Spread direction="horizontal" space="small" alignY="center">
          {email ? <Text size="small">{email}</Text> : <Box />}
          <ButtonIcon
            icon={<IconClear />}
            variant="soft"
            tone="neutral"
            onClick={onLogout}
            size="small"
            label="Log out"
          />
        </Spread>
      </Box>
    </ContentBlock>
  </Box>
);
